import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import isNumber from "lodash/isNumber";
import { Clock, HandGrab, Handshake, Send, UserRoundX } from "lucide-react";
import Item from "./Item";
import { useCompanyPreferences } from "../../../../../Settings/Configuration/hooks/usePreferences";
import useApi from "utils/api";

export const STATISTICS_URL = "/request/open-shifts/statistics";

type Statistics = {
    total: number;
    pending: number;
    approved: number;
    denied: number;
    expired: number;
    closed: number;
    needsApproval: number;
    needsCoverage: number;
    pastDeadline: number;
    directOffers: number;
    byStatus: Record<string, number>;
};

type WidgetProps = {
    params: Record<string, unknown>;
};

function Widget({ params }: WidgetProps) {
    const { t } = useTranslation();
    const { authGet } = useApi();
    const coverageDeadline = useCompanyPreferences("requests.openShift.coverageDeadline") || 3;

    const { data } = useQuery<Statistics>({
        queryKey: [STATISTICS_URL, params],
        queryFn: ({ queryKey, signal }: any) => {
            const [url, params] = queryKey;
            return authGet(url, { params, signal });
        },
    });

    return (
        <div className="tw-flex w-full tw-gap-x-2 tw-px-5 tw-pb-5">
            <Item icon={UserRoundX} title={t("open-spots")} value={data?.needsCoverage ?? 0} />
            <Item icon={HandGrab} title={t("waiting-for-approval")} value={data?.needsApproval ?? 0} />
            <Item icon={Handshake} title={t("direct-offers-awaiting-response")} value={data?.directOffers ?? 0} />
            {isNumber(coverageDeadline) && (
                <Item
                    icon={Clock}
                    title={t("offers-closing-within-amount-hours", { time: `${coverageDeadline}h` })}
                    value={data?.pastDeadline ?? 0}
                />
            )}
            <Item icon={Send} title={t("offers-out")} value={data?.closed ?? 0} />
        </div>
    );
}

export default Widget;
